'use es6';

export const getDesktopPreview = state => state.preview.desktop;
export const getMobilePreview = state => state.preview.mobile;